export default __webpack_public_path__ + "images/b2f573726066e1a5bb902eaca27bf92a-paypal-button.svg";